import axios from "./Api";

export const getWarehouseAccessList = async () => {
  const url = `/api/app/warehouse-access`;
  const data = await axios.get(url);
  return data;
};

export const DeleteWarehosueAccess = async (id: number) => {
  const url = `/api/app/warehouse-access/${id}`;
  const data = await axios.delete(url);
  return data;
};

export const AddWarehosueAccess = async (params: any) => {
  const url = `/api/app/warehouse-access/by-email/${params.id}?email=${params.email}`;
  const data = await axios.post(url, params);
  return data;
};
